const isAbsoluteLink = (url: string): boolean => {
	return url.startsWith('http') || url.startsWith('www');
};
/**
 * For a given arbitrary path, we will prefix it with a context path of People page.
 * For example: Em-Dir in Confluence
 * - A given path is `hello-world/123`
 * - Output will be `/wiki/people/hello-world/123`
 */
export const prefixWithContextEntryPoint = (
	path: string,
	contextEntryPoint: string | null = '',
): string => {
	if (
		isAbsoluteLink(path) || // do not prefix for absolute URL
		(contextEntryPoint && path.startsWith(contextEntryPoint)) || // do not prefix if the link already has product context path
		path.startsWith('/')
	) {
		return path;
	}

	return `${contextEntryPoint}/${path}`;
};
